<template>
    <nuxt-layout name="main-big" :dark="true" :favorite="true">
        <!-- * 基因搜索窗口 -->
        <search-gene-modal ref="modal" trigger="none" @change="methods.open" />
        <!-- * 模型介绍 -->
        <ui-modal ref="info" height="auto" spacing="32px 56px 40px">
            <div class="text-emphas text-[30px] leading-[46px] font-bold">{{ $t("ModelIntroduction") }}</div>
            <div class="mt-[16px]">
                <p>{{ $t("SequenceViewerIntroduction") }}</p>
            </div>
        </ui-modal>

        <div :class="css.container" class="container">
            <!-- * 头部 -->
            <div :class="css.header" class="color-1 font-bold">
                <div :class="css.name" class="font-variable">{{ $t("SequenceViewer") }}</div>
                <div :class="css.descript" class="font-variable">{{ $t("SequenceViewerVice") }}</div>
            </div>

            <ToolSearch
                size="large"
                :class="css.input"
                ref="search"
                v-model="keyword"
                :placeholder="$t('Placeholder.SearchGeneOrID', 2)"
                @search="modal?.open(keyword)" />

            <div class="flex items-center justify-center mt-[80px] max-xl:mt-[64px]">
                <div class="transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="info?.openModal()">
                    {{ $t("ModelIntroduction") }}
                </div>
                <template v-if="$i18n.locale == 'zh'">
                    <div class="w-[1px] h-[12px] mx-[16px] bg-emphas"></div>
                    <div class="transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="methods.next">
                        {{ $t("VideoTutorial") }}
                    </div>
                </template>
            </div>
        </div>
    </nuxt-layout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiModal } from "various-ui";
//* 公共组件
import { SearchGeneModal } from "@/components/windows";
import { ToolSearch } from "@/components/controls";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 组合函数
const { refs, nodes, methods } = useComposable();
const { keyword } = refs;
const { info, modal } = nodes;
</script>
